<template>
  <b-card
    class="small-card"
    no-body
  >
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <div class="title-text">
          {{ titleText }}
        </div>
        <div class="value-text">
          {{ valueText }}
        </div>
      </div>
      <div v-if="iconName">
        <div
          :class="'bg-light-' + colorVariant"
          class="rounded-pill width-50 height-50 d-flex align-items-center justify-content-center"
        >
          <FeatherIcon
            :icon="iconName"
            size="18"
          />
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'CounterCard',
  components: {
    BCard,
  },
  props: {
    titleText: {
      type: String,
      required: true,
    },
    valueText: {
      type: String,
      required: true,
    },
    colorVariant: {
      type: String,
      default: 'primary',
    },
    iconName: {
      type: String,
      default: '',
    },
  },
}
</script>
<style scoped>
.small-card{
  padding: 15px !important;
}
.small-card .title-text{
  font-size: 16px !important;
  font-weight: 500 !important;
}
.small-card .value-text{
  font-size: 24px !important;
  font-weight: 600 !important;
}
</style>
